import {actionType} from '../types/type';
import { updateObject } from '../../helpers/utility.helper';
import IPageLimit from '../../models/IPageLimit';
import { initialState } from '../state/pager.state';

const getPager = (oldState:IPageLimit, action: any) => {
	return updateObject(oldState, {
        pageLimit:action.payload,
        isPageLimitLoaded: true
    });
};

const resetPager = (oldState:IPageLimit, action: any) => {
	return updateObject(oldState, {
        pageLimit:100,
        isPageLimitLoaded: false
    });
};

const updatePager = (oldState:IPageLimit, action: any) => {
	return updateObject(oldState, {
        pageLimit: Number(action.payload),
        isPageLimitLoaded: true
    });
};

const pagerReducer = (oldState:IPageLimit = initialState, action:any) => {
    switch (action.type) {
        case actionType.GET_PAGE_LIMIT: return getPager(oldState, action);
        case actionType.PAGE_LIMIT_UPDATED: return updatePager(oldState, action);
        case actionType.RESET_PAGE_LIMIT: return resetPager(oldState, action);
        default: return oldState;    
    }
};
export default pagerReducer;